/**
 * `assignedUserId` narrows the directory to a single caller's own dossiers — a display convenience
 * when the caller lacks the facility-wide permission (`WORKFLOW_RUN_FACILITY_READ`); the server
 * decides the real visibility scope regardless of what is sent here.
 */
class FetchBeneficiaryDirectory {
	constructor(
		public readonly accountId: number,
		public readonly facilityId: number,
		public readonly assignedUserId: number | null,
	) {
		Object.freeze(this);
	}
}

export default FetchBeneficiaryDirectory;
